import { axios } from '@/utils/request'

const api = {
  pendingMatter: '/backlog/pendingMatter',
  role: '/system/role',
}
// 待办事项类表
export function pendingMatterList (parameter) {
  return axios({
    url: api.pendingMatter + '/list',
    method: 'get',
    params: parameter
  })
}
// 待办事项详情
export function pendingMatterInfo (parameter) {
  return axios({
    url: api.pendingMatter + '//info',
    method: 'get',
    params: parameter
  })
}
// 接收人，抄送人
export function getPendingMattersRoleList (parameter) {
  return axios({
    url: api.pendingMatter + '/getPendingMattersRoleList',
    method: 'get',
    params: parameter
  })
}
// 发送人
export function roleList (parameter) {
  return axios({
    url: api.role + '/list',
    method: 'get',
    params: parameter
  })
}
// 编辑
export function update (parameter) {
  return axios({
    url: api.pendingMatter + '/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export const accessoryExport = api.accessory + '/export'